/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseApi } from '../store/baseApi';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: unknown; output: unknown; }
};

export type NotificationStripType =
  | 'CRITICAL'
  | 'INFO'
  | 'MAINTENANCE'
  | 'WARNING';


export type AddressFieldsFragment = { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null };

export type CustomerFieldsFragment = { id: string, name: string, phone: string | null, email: string | null, openingBalance: number | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null };

export type VendorFieldsFragment = { id: string, name: string, phone: string | null, email: string | null, openingBalance: number | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null };

export type WarehouseFieldsFragment = { id: string, name: string, phone: string | null, email: string | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null };

export type ModuleCommentFieldsFragment = { id: string, type: string, content: string, createdAt: string, createdByUser: unknown };

export type TenantBySlugQueryVariables = Exact<{
  slug: string;
}>;


export type TenantBySlugQuery = { tenantBySlug: { variantName: string, theme: unknown, tenant: { id: string, name: string, slug: string, plan: string, status: string }, config: { defaultContextLogin: boolean, loginType: string, logoUrl: string | null, maxOrgs: number | null, maxUsers: number | null, enabledModules: Array<string> | null } | null, orgs: Array<{ id: string, name: string, uniqueId: string | null, status: string | null }> } };

export type LoginMutationVariables = Exact<{
  phone: string;
}>;


export type LoginMutation = { login: unknown };

export type VerifyOtpMutationVariables = Exact<{
  phone: string;
  otp: string;
}>;


export type VerifyOtpMutation = { verifyOtp: { user: { id: string, name: string, phone: string, email: string | null }, orgs: Array<{ orgId: string, name: string | null, membershipId: string }> } };

export type InitAppMutationVariables = Exact<{
  userId: string | number;
  orgId: string | number;
}>;


export type InitAppMutation = { initApp: { accessToken: string, refreshToken: string, featureKeys: Array<string>, socketRooms: Array<string | null>, org: unknown, tenant: unknown, theme: unknown, currentRole: unknown, user: unknown, pendingTaskCount: number, operationsLocked: boolean, orgs: Array<{ orgId: string, name: string | null, membershipId: string }> } };

export type RefreshSessionMutationVariables = Exact<{
  refreshToken: string;
}>;


export type RefreshSessionMutation = { refreshSession: { accessToken: string, refreshToken: string, featureKeys: Array<string>, socketRooms: Array<string | null>, org: unknown, tenant: unknown, theme: unknown, currentRole: unknown, user: unknown, pendingTaskCount: number, operationsLocked: boolean, orgs: Array<{ orgId: string, name: string | null, membershipId: string }> } };

export type ListCustomersQueryVariables = Exact<{
  page?: number | null | undefined;
  pageLimit?: number | null | undefined;
  search?: string | null | undefined;
}>;


export type ListCustomersQuery = { listCustomers: { total: number, page: number, pageLimit: number, rows: Array<{ id: string, name: string, phone: string | null, email: string | null, openingBalance: number | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null }> } };

export type GetCustomerQueryVariables = Exact<{
  id: string | number;
}>;


export type GetCustomerQuery = { getCustomer: { id: string, name: string, phone: string | null, email: string | null, openingBalance: number | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null } | null };

export type AddUpdateCustomerMutationVariables = Exact<{
  input: unknown;
}>;


export type AddUpdateCustomerMutation = { addUpdateCustomer: { id: string, name: string, phone: string | null, email: string | null, openingBalance: number | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null } };

export type DeleteCustomerMutationVariables = Exact<{
  customerId: string | number;
}>;


export type DeleteCustomerMutation = { deleteCustomer: unknown };

export type CustomerCommentsQueryVariables = Exact<{
  customerId: string | number;
}>;


export type CustomerCommentsQuery = { customerComments: Array<{ id: string, type: string, content: string, createdAt: string, createdByUser: unknown }> };

export type AddCustomerCommentMutationVariables = Exact<{
  customerId: string | number;
  content: string;
}>;


export type AddCustomerCommentMutation = { addCustomerComment: { id: string, type: string, content: string, createdAt: string, createdByUser: unknown } };

export type ListVendorsQueryVariables = Exact<{
  page?: number | null | undefined;
  pageLimit?: number | null | undefined;
  search?: string | null | undefined;
}>;


export type ListVendorsQuery = { listVendors: { total: number, page: number, pageLimit: number, rows: Array<{ id: string, name: string, phone: string | null, email: string | null, openingBalance: number | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null }> } };

export type GetVendorQueryVariables = Exact<{
  id: string | number;
}>;


export type GetVendorQuery = { getVendor: { id: string, name: string, phone: string | null, email: string | null, openingBalance: number | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null } | null };

export type AddUpdateVendorMutationVariables = Exact<{
  input: unknown;
}>;


export type AddUpdateVendorMutation = { addUpdateVendor: { id: string, name: string, phone: string | null, email: string | null, openingBalance: number | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null } };

export type DeleteVendorMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteVendorMutation = { deleteVendor: unknown };

export type AddUpdateWarehouseMutationVariables = Exact<{
  input: unknown;
}>;


export type AddUpdateWarehouseMutation = { addUpdateWarehouse: { id: string, name: string, phone: string | null, email: string | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null } };

export type DeleteWarehouseMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteWarehouseMutation = { deleteWarehouse: unknown };

export type ListLabourQueryVariables = Exact<{
  page?: number | null | undefined;
  pageLimit?: number | null | undefined;
  search?: string | null | undefined;
}>;


export type ListLabourQuery = { listLabour: { total: number, page: number, pageLimit: number, rows: Array<{ id: string, name: string, phone: string | null }> } };

export type AddUpdateLabourMutationVariables = Exact<{
  input: unknown;
}>;


export type AddUpdateLabourMutation = { addUpdateLabour: { id: string, name: string, phone: string | null } };

export type DeleteLabourMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteLabourMutation = { deleteLabour: unknown };

export type ListTransportQueryVariables = Exact<{
  page?: number | null | undefined;
  pageLimit?: number | null | undefined;
  search?: string | null | undefined;
}>;


export type ListTransportQuery = { listTransport: { total: number, page: number, pageLimit: number, rows: Array<{ id: string, name: string, phone: string | null }> } };

export type AddUpdateTransportMutationVariables = Exact<{
  input: unknown;
}>;


export type AddUpdateTransportMutation = { addUpdateTransport: { id: string, name: string, phone: string | null } };

export type DeleteTransportMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteTransportMutation = { deleteTransport: unknown };

export type ListWarehousesQueryVariables = Exact<{
  page?: number | null | undefined;
  pageLimit?: number | null | undefined;
  search?: string | null | undefined;
}>;


export type ListWarehousesQuery = { listWarehouses: { total: number, page: number, pageLimit: number, rows: Array<{ id: string, name: string, phone: string | null, email: string | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null }> } };

export type SystemNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type SystemNotificationsQuery = { systemNotifications: Array<{ id: string, message: string, type: NotificationStripType, priority: number, activeFrom: string | null, activeTo: string | null, isActive: boolean }> };

export type ListProcurementQueryVariables = Exact<{
  listType?: string | null | undefined;
  page?: number | null | undefined;
  pageLimit?: number | null | undefined;
  customerId?: string | number | null | undefined;
  vendorId?: string | number | null | undefined;
  productId?: string | number | null | undefined;
}>;


export type ListProcurementQuery = { listProcurement: { total: number, page: number, pageLimit: number, rows: Array<{ id: string, procType: string, ordNumber: string | null, procAmount: number | null, procUrl: string | null, customerId: string | null, vendorId: string | null, warehouseId: string | null, createdAt: string | null }> } };

export type GetProcurementQueryVariables = Exact<{
  id: string | number;
}>;


export type GetProcurementQuery = { getProcurement: { id: string, procType: string, ordNumber: string | null, procAmount: number | null, procUrl: string | null, createdAt: string | null, taxAmount: number | null, discountAmount: number | null, chargesAmount: number | null, remarks: string | null, vehicleNo: string | null, biltyNo: string | null, customer: { id: string, name: string, phone: string | null, email: string | null, openingBalance: number | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null } | null, vendor: { id: string, name: string, phone: string | null, email: string | null, openingBalance: number | null, address: { id: string, line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null, latitude: number | null, longitude: number | null } | null } | null, labour: { id: string, name: string, phone: string | null } | null, transport: { id: string, name: string, phone: string | null } | null, products: Array<{ id: string, quantity: number | null, productId: string | null, pricePerUnit: number | null, productPrice: number | null, qtyUnit: string | null, addOnItemQty: number | null, product: { id: string, name: string, unit: string | null, imageUrl: string | null } | null }> | null } | null };

export type AddUpdateProcurementMutationVariables = Exact<{
  input: unknown;
}>;


export type AddUpdateProcurementMutation = { addUpdateProcurement: { id: string, procType: string, ordNumber: string | null, procAmount: number | null, procUrl: string | null, customerId: string | null, vendorId: string | null, warehouseId: string | null } };

export type ExportProcurementMutationVariables = Exact<{
  filters?: unknown;
}>;


export type ExportProcurementMutation = { exportProcurement: { jobId: string } };

export type FileUrlQueryVariables = Exact<{
  key: string;
}>;


export type FileUrlQuery = { fileUrl: { url: string, expiresAt: string } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const AddressFieldsFragmentDoc = new TypedDocumentString(`
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}
    `, {"fragmentName":"AddressFields"});
export const CustomerFieldsFragmentDoc = new TypedDocumentString(`
    fragment CustomerFields on Customer {
  id
  name
  phone
  email
  openingBalance
  address {
    ...AddressFields
  }
}
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}`, {"fragmentName":"CustomerFields"});
export const VendorFieldsFragmentDoc = new TypedDocumentString(`
    fragment VendorFields on Vendor {
  id
  name
  phone
  email
  openingBalance
  address {
    ...AddressFields
  }
}
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}`, {"fragmentName":"VendorFields"});
export const WarehouseFieldsFragmentDoc = new TypedDocumentString(`
    fragment WarehouseFields on Warehouse {
  id
  name
  phone
  email
  approvalStatus
  approvedById
  approvedAt
  address {
    ...AddressFields
  }
}
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}`, {"fragmentName":"WarehouseFields"});
export const ModuleCommentFieldsFragmentDoc = new TypedDocumentString(`
    fragment ModuleCommentFields on ModuleComment {
  id
  type
  content
  createdAt
  createdByUser
}
    `, {"fragmentName":"ModuleCommentFields"});
export const TenantBySlugDocument = new TypedDocumentString(`
    query TenantBySlug($slug: String!) {
  tenantBySlug(slug: $slug) {
    tenant {
      id
      name
      slug
      plan
      status
    }
    variantName
    theme
    config {
      defaultContextLogin
      loginType
      logoUrl
      maxOrgs
      maxUsers
      enabledModules
    }
    orgs {
      id
      name
      uniqueId
      status
    }
  }
}
    `);
export const LoginDocument = new TypedDocumentString(`
    mutation Login($phone: String!) {
  login(phone: $phone)
}
    `);
export const VerifyOtpDocument = new TypedDocumentString(`
    mutation VerifyOtp($phone: String!, $otp: String!) {
  verifyOtp(phone: $phone, otp: $otp) {
    user {
      id
      name
      phone
      email
    }
    orgs {
      orgId
      name
      membershipId
    }
  }
}
    `);
export const InitAppDocument = new TypedDocumentString(`
    mutation InitApp($userId: ID!, $orgId: ID!) {
  initApp(userId: $userId, orgId: $orgId) {
    accessToken
    refreshToken
    featureKeys
    socketRooms
    org
    tenant
    theme
    currentRole
    user
    orgs {
      orgId
      name
      membershipId
    }
    pendingTaskCount
    operationsLocked
  }
}
    `);
export const RefreshSessionDocument = new TypedDocumentString(`
    mutation RefreshSession($refreshToken: String!) {
  refreshSession(refreshToken: $refreshToken) {
    accessToken
    refreshToken
    featureKeys
    socketRooms
    org
    tenant
    theme
    currentRole
    user
    orgs {
      orgId
      name
      membershipId
    }
    pendingTaskCount
    operationsLocked
  }
}
    `);
export const ListCustomersDocument = new TypedDocumentString(`
    query ListCustomers($page: Int, $pageLimit: Int, $search: String) {
  listCustomers(page: $page, pageLimit: $pageLimit, search: $search) {
    rows {
      ...CustomerFields
    }
    total
    page
    pageLimit
  }
}
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}
fragment CustomerFields on Customer {
  id
  name
  phone
  email
  openingBalance
  address {
    ...AddressFields
  }
}`);
export const GetCustomerDocument = new TypedDocumentString(`
    query GetCustomer($id: ID!) {
  getCustomer(id: $id) {
    ...CustomerFields
  }
}
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}
fragment CustomerFields on Customer {
  id
  name
  phone
  email
  openingBalance
  address {
    ...AddressFields
  }
}`);
export const AddUpdateCustomerDocument = new TypedDocumentString(`
    mutation AddUpdateCustomer($input: JSON!) {
  addUpdateCustomer(input: $input) {
    ...CustomerFields
  }
}
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}
fragment CustomerFields on Customer {
  id
  name
  phone
  email
  openingBalance
  address {
    ...AddressFields
  }
}`);
export const DeleteCustomerDocument = new TypedDocumentString(`
    mutation DeleteCustomer($customerId: ID!) {
  deleteCustomer(customerId: $customerId)
}
    `);
export const CustomerCommentsDocument = new TypedDocumentString(`
    query CustomerComments($customerId: ID!) {
  customerComments(customerId: $customerId) {
    ...ModuleCommentFields
  }
}
    fragment ModuleCommentFields on ModuleComment {
  id
  type
  content
  createdAt
  createdByUser
}`);
export const AddCustomerCommentDocument = new TypedDocumentString(`
    mutation AddCustomerComment($customerId: ID!, $content: String!) {
  addCustomerComment(customerId: $customerId, content: $content) {
    ...ModuleCommentFields
  }
}
    fragment ModuleCommentFields on ModuleComment {
  id
  type
  content
  createdAt
  createdByUser
}`);
export const ListVendorsDocument = new TypedDocumentString(`
    query ListVendors($page: Int, $pageLimit: Int, $search: String) {
  listVendors(page: $page, pageLimit: $pageLimit, search: $search) {
    rows {
      ...VendorFields
    }
    total
    page
    pageLimit
  }
}
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}
fragment VendorFields on Vendor {
  id
  name
  phone
  email
  openingBalance
  address {
    ...AddressFields
  }
}`);
export const GetVendorDocument = new TypedDocumentString(`
    query GetVendor($id: ID!) {
  getVendor(id: $id) {
    ...VendorFields
  }
}
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}
fragment VendorFields on Vendor {
  id
  name
  phone
  email
  openingBalance
  address {
    ...AddressFields
  }
}`);
export const AddUpdateVendorDocument = new TypedDocumentString(`
    mutation AddUpdateVendor($input: JSON!) {
  addUpdateVendor(input: $input) {
    ...VendorFields
  }
}
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}
fragment VendorFields on Vendor {
  id
  name
  phone
  email
  openingBalance
  address {
    ...AddressFields
  }
}`);
export const DeleteVendorDocument = new TypedDocumentString(`
    mutation DeleteVendor($id: ID!) {
  deleteVendor(id: $id)
}
    `);
export const AddUpdateWarehouseDocument = new TypedDocumentString(`
    mutation AddUpdateWarehouse($input: JSON!) {
  addUpdateWarehouse(input: $input) {
    ...WarehouseFields
  }
}
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}
fragment WarehouseFields on Warehouse {
  id
  name
  phone
  email
  approvalStatus
  approvedById
  approvedAt
  address {
    ...AddressFields
  }
}`);
export const DeleteWarehouseDocument = new TypedDocumentString(`
    mutation DeleteWarehouse($id: ID!) {
  deleteWarehouse(id: $id)
}
    `);
export const ListLabourDocument = new TypedDocumentString(`
    query ListLabour($page: Int, $pageLimit: Int, $search: String) {
  listLabour(page: $page, pageLimit: $pageLimit, search: $search) {
    rows {
      id
      name
      phone
    }
    total
    page
    pageLimit
  }
}
    `);
export const AddUpdateLabourDocument = new TypedDocumentString(`
    mutation AddUpdateLabour($input: JSON!) {
  addUpdateLabour(input: $input) {
    id
    name
    phone
  }
}
    `);
export const DeleteLabourDocument = new TypedDocumentString(`
    mutation DeleteLabour($id: ID!) {
  deleteLabour(id: $id)
}
    `);
export const ListTransportDocument = new TypedDocumentString(`
    query ListTransport($page: Int, $pageLimit: Int, $search: String) {
  listTransport(page: $page, pageLimit: $pageLimit, search: $search) {
    rows {
      id
      name
      phone
    }
    total
    page
    pageLimit
  }
}
    `);
export const AddUpdateTransportDocument = new TypedDocumentString(`
    mutation AddUpdateTransport($input: JSON!) {
  addUpdateTransport(input: $input) {
    id
    name
    phone
  }
}
    `);
export const DeleteTransportDocument = new TypedDocumentString(`
    mutation DeleteTransport($id: ID!) {
  deleteTransport(id: $id)
}
    `);
export const ListWarehousesDocument = new TypedDocumentString(`
    query ListWarehouses($page: Int, $pageLimit: Int, $search: String) {
  listWarehouses(page: $page, pageLimit: $pageLimit, search: $search) {
    rows {
      ...WarehouseFields
    }
    total
    page
    pageLimit
  }
}
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}
fragment WarehouseFields on Warehouse {
  id
  name
  phone
  email
  approvalStatus
  approvedById
  approvedAt
  address {
    ...AddressFields
  }
}`);
export const SystemNotificationsDocument = new TypedDocumentString(`
    query SystemNotifications {
  systemNotifications {
    id
    message
    type
    priority
    activeFrom
    activeTo
    isActive
  }
}
    `);
export const ListProcurementDocument = new TypedDocumentString(`
    query ListProcurement($listType: String, $page: Int, $pageLimit: Int, $customerId: ID, $vendorId: ID, $productId: ID) {
  listProcurement(
    listType: $listType
    page: $page
    pageLimit: $pageLimit
    customerId: $customerId
    vendorId: $vendorId
    productId: $productId
  ) {
    rows {
      id
      procType
      ordNumber
      procAmount
      procUrl
      customerId
      vendorId
      warehouseId
      createdAt
    }
    total
    page
    pageLimit
  }
}
    `);
export const GetProcurementDocument = new TypedDocumentString(`
    query GetProcurement($id: ID!) {
  getProcurement(id: $id) {
    id
    procType
    ordNumber
    procAmount
    procUrl
    createdAt
    taxAmount
    discountAmount
    chargesAmount
    remarks
    vehicleNo
    biltyNo
    customer {
      ...CustomerFields
    }
    vendor {
      ...VendorFields
    }
    labour {
      id
      name
      phone
    }
    transport {
      id
      name
      phone
    }
    products {
      id
      quantity
      productId
      pricePerUnit
      productPrice
      qtyUnit
      addOnItemQty
      product {
        id
        name
        unit
        imageUrl
      }
    }
  }
}
    fragment AddressFields on Address {
  id
  line1
  line2
  city
  state
  postalCode
  country
  latitude
  longitude
}
fragment CustomerFields on Customer {
  id
  name
  phone
  email
  openingBalance
  address {
    ...AddressFields
  }
}
fragment VendorFields on Vendor {
  id
  name
  phone
  email
  openingBalance
  address {
    ...AddressFields
  }
}`);
export const AddUpdateProcurementDocument = new TypedDocumentString(`
    mutation AddUpdateProcurement($input: JSON!) {
  addUpdateProcurement(input: $input) {
    id
    procType
    ordNumber
    procAmount
    procUrl
    customerId
    vendorId
    warehouseId
  }
}
    `);
export const ExportProcurementDocument = new TypedDocumentString(`
    mutation ExportProcurement($filters: JSON) {
  exportProcurement(filters: $filters) {
    jobId
  }
}
    `);
export const FileUrlDocument = new TypedDocumentString(`
    query FileUrl($key: String!) {
  fileUrl(key: $key) {
    url
    expiresAt
  }
}
    `);

const injectedRtkApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    TenantBySlug: build.query<TenantBySlugQuery, TenantBySlugQueryVariables>({
      query: (variables) => ({ document: TenantBySlugDocument as unknown as string, variables })
    }),
    Login: build.mutation<LoginMutation, LoginMutationVariables>({
      query: (variables) => ({ document: LoginDocument as unknown as string, variables })
    }),
    VerifyOtp: build.mutation<VerifyOtpMutation, VerifyOtpMutationVariables>({
      query: (variables) => ({ document: VerifyOtpDocument as unknown as string, variables })
    }),
    InitApp: build.mutation<InitAppMutation, InitAppMutationVariables>({
      query: (variables) => ({ document: InitAppDocument as unknown as string, variables })
    }),
    RefreshSession: build.mutation<RefreshSessionMutation, RefreshSessionMutationVariables>({
      query: (variables) => ({ document: RefreshSessionDocument as unknown as string, variables })
    }),
    ListCustomers: build.query<ListCustomersQuery, ListCustomersQueryVariables | void>({
      query: (variables) => ({ document: ListCustomersDocument as unknown as string, variables })
    }),
    GetCustomer: build.query<GetCustomerQuery, GetCustomerQueryVariables>({
      query: (variables) => ({ document: GetCustomerDocument as unknown as string, variables })
    }),
    AddUpdateCustomer: build.mutation<AddUpdateCustomerMutation, AddUpdateCustomerMutationVariables>({
      query: (variables) => ({ document: AddUpdateCustomerDocument as unknown as string, variables })
    }),
    DeleteCustomer: build.mutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>({
      query: (variables) => ({ document: DeleteCustomerDocument as unknown as string, variables })
    }),
    CustomerComments: build.query<CustomerCommentsQuery, CustomerCommentsQueryVariables>({
      query: (variables) => ({ document: CustomerCommentsDocument as unknown as string, variables })
    }),
    AddCustomerComment: build.mutation<AddCustomerCommentMutation, AddCustomerCommentMutationVariables>({
      query: (variables) => ({ document: AddCustomerCommentDocument as unknown as string, variables })
    }),
    ListVendors: build.query<ListVendorsQuery, ListVendorsQueryVariables | void>({
      query: (variables) => ({ document: ListVendorsDocument as unknown as string, variables })
    }),
    GetVendor: build.query<GetVendorQuery, GetVendorQueryVariables>({
      query: (variables) => ({ document: GetVendorDocument as unknown as string, variables })
    }),
    AddUpdateVendor: build.mutation<AddUpdateVendorMutation, AddUpdateVendorMutationVariables>({
      query: (variables) => ({ document: AddUpdateVendorDocument as unknown as string, variables })
    }),
    DeleteVendor: build.mutation<DeleteVendorMutation, DeleteVendorMutationVariables>({
      query: (variables) => ({ document: DeleteVendorDocument as unknown as string, variables })
    }),
    AddUpdateWarehouse: build.mutation<AddUpdateWarehouseMutation, AddUpdateWarehouseMutationVariables>({
      query: (variables) => ({ document: AddUpdateWarehouseDocument as unknown as string, variables })
    }),
    DeleteWarehouse: build.mutation<DeleteWarehouseMutation, DeleteWarehouseMutationVariables>({
      query: (variables) => ({ document: DeleteWarehouseDocument as unknown as string, variables })
    }),
    ListLabour: build.query<ListLabourQuery, ListLabourQueryVariables | void>({
      query: (variables) => ({ document: ListLabourDocument as unknown as string, variables })
    }),
    AddUpdateLabour: build.mutation<AddUpdateLabourMutation, AddUpdateLabourMutationVariables>({
      query: (variables) => ({ document: AddUpdateLabourDocument as unknown as string, variables })
    }),
    DeleteLabour: build.mutation<DeleteLabourMutation, DeleteLabourMutationVariables>({
      query: (variables) => ({ document: DeleteLabourDocument as unknown as string, variables })
    }),
    ListTransport: build.query<ListTransportQuery, ListTransportQueryVariables | void>({
      query: (variables) => ({ document: ListTransportDocument as unknown as string, variables })
    }),
    AddUpdateTransport: build.mutation<AddUpdateTransportMutation, AddUpdateTransportMutationVariables>({
      query: (variables) => ({ document: AddUpdateTransportDocument as unknown as string, variables })
    }),
    DeleteTransport: build.mutation<DeleteTransportMutation, DeleteTransportMutationVariables>({
      query: (variables) => ({ document: DeleteTransportDocument as unknown as string, variables })
    }),
    ListWarehouses: build.query<ListWarehousesQuery, ListWarehousesQueryVariables | void>({
      query: (variables) => ({ document: ListWarehousesDocument as unknown as string, variables })
    }),
    SystemNotifications: build.query<SystemNotificationsQuery, SystemNotificationsQueryVariables | void>({
      query: (variables) => ({ document: SystemNotificationsDocument as unknown as string, variables })
    }),
    ListProcurement: build.query<ListProcurementQuery, ListProcurementQueryVariables | void>({
      query: (variables) => ({ document: ListProcurementDocument as unknown as string, variables })
    }),
    GetProcurement: build.query<GetProcurementQuery, GetProcurementQueryVariables>({
      query: (variables) => ({ document: GetProcurementDocument as unknown as string, variables })
    }),
    AddUpdateProcurement: build.mutation<AddUpdateProcurementMutation, AddUpdateProcurementMutationVariables>({
      query: (variables) => ({ document: AddUpdateProcurementDocument as unknown as string, variables })
    }),
    ExportProcurement: build.mutation<ExportProcurementMutation, ExportProcurementMutationVariables | void>({
      query: (variables) => ({ document: ExportProcurementDocument as unknown as string, variables })
    }),
    FileUrl: build.query<FileUrlQuery, FileUrlQueryVariables>({
      query: (variables) => ({ document: FileUrlDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useTenantBySlugQuery, useLazyTenantBySlugQuery, useLoginMutation, useVerifyOtpMutation, useInitAppMutation, useRefreshSessionMutation, useListCustomersQuery, useLazyListCustomersQuery, useGetCustomerQuery, useLazyGetCustomerQuery, useAddUpdateCustomerMutation, useDeleteCustomerMutation, useCustomerCommentsQuery, useLazyCustomerCommentsQuery, useAddCustomerCommentMutation, useListVendorsQuery, useLazyListVendorsQuery, useGetVendorQuery, useLazyGetVendorQuery, useAddUpdateVendorMutation, useDeleteVendorMutation, useAddUpdateWarehouseMutation, useDeleteWarehouseMutation, useListLabourQuery, useLazyListLabourQuery, useAddUpdateLabourMutation, useDeleteLabourMutation, useListTransportQuery, useLazyListTransportQuery, useAddUpdateTransportMutation, useDeleteTransportMutation, useListWarehousesQuery, useLazyListWarehousesQuery, useSystemNotificationsQuery, useLazySystemNotificationsQuery, useListProcurementQuery, useLazyListProcurementQuery, useGetProcurementQuery, useLazyGetProcurementQuery, useAddUpdateProcurementMutation, useExportProcurementMutation, useFileUrlQuery, useLazyFileUrlQuery } = injectedRtkApi;

